import styled from 'styled-components'

export const NursingIndicator = styled.div`
  margin-bottom: 64px;

  &:last-child {
    margin-bottom: 0;
  }

  .indicator-legend-accordion {
    margin-bottom: 16px;
  }

  .indicator-wrapper {
    display: flex;

    .indicator-enumeration {
      margin-right: 8px;
    }
  }

  .indicator-title {
    display: flex;
    flex-grow: 1;

    @media ${ (props) => props.theme.breakpoints.devices.max.xs } {
      flex-direction: column;

      .more-details-button {
        margin-top: 16px;
        margin-left: 0;
      }

      .indicator-rating {
        margin-left: 0;
      }
    }
  }

  .indicator-types {
    margin-left: 22px;
    margin-top: 24px;

    .indicator-wrapper {
      @media ${ (props) => props.theme.breakpoints.devices.max.xs } {
        margin-bottom: 24px;

        &:last-child {
          margin-bottom: 0;
        }
      }
    }

    .indicator-type {
      display: flex;
      flex-grow: 1;
      align-items: baseline;

      & > p {
        flex-grow: 1;
      }

      @media ${ (props) => props.theme.breakpoints.devices.max.xs } {
        flex-direction: column;
        margin-bottom: 24px;

        &:last-child {
          margin-bottom: 0;
        }

        .more-details-button {
          margin-top: 16px;
          margin-left: 0;
        }

        .indicator-rating {
          margin-left: 0;
        }
      }
    }
  }

  .indicator-type-description {
    margin-right: 24px;
    flex-grow: 1;
  }

  .indicator-type-char {
    margin-right: 8px;
  }

  .more-details-button {
    margin-left: 40px;
    display: inline-flex;
    min-width: 100px;
    text-decoration: none;
  }

  .indicator-rating {
    min-width: 112px;
    margin-left: 24px;
  }
`
